export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = 'FETCH_CLIENTS_FAILURE';

export const FETCH_ALL_CLIENTS_DATA_REQUEST = 'FETCH_ALL_CLIENTS_DATA_REQUEST';
export const FETCH_ALL_CLIENTS_DATA_SUCCESS = 'FETCH_ALL_CLIENTS_DATA_SUCCESS';
export const FETCH_ALL_CLIENTS_DATA_FAILURE = 'FETCH_ALL_CLIENTS_DATA_FAILURE';

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE';

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE';

export const UPDATE_CLIENT_SECURITY_REQUEST = 'UPDATE_CLIENT_SECURITY_REQUEST';
export const UPDATE_CLIENT_SECURITY_SUCCESS = 'UPDATE_CLIENT_SECURITY_SUCCESS';
export const UPDATE_CLIENT_SECURITY_FAILURE = 'UPDATE_CLIENT_SECURITY_FAILURE';

export const SET_CLIENT_FILTER = 'SET_CLIENT_FILTER';
